export const COUPON_PLANS = [['pro_monthly', 'Pro Monthly'], ['pro_annual', 'Pro Annual'], ['officials_annual', 'Officials add-on'], ['bundle_annual', 'Pro + Officials Bundle']];

const planName = (id) => (COUPON_PLANS.find(([v]) => v === id) || [id, id])[1];

export const couponSummary = (c) => (c.type === 'percent'
  ? `${c.percent_off}% off ${(c.applies_to || []).map(planName).join(', ')} · ${c.duration === 'forever' ? 'every renewal' : 'first payment only'} · card only`
  : `${c.trial_days} free Pro days`);
